<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span><svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<h2 modal-title>Gaat u verhuizen?</h2>
<div modal-content>
    <p>We zien dat u uw Woonverzekering bij ons heeft stopgezet. Bent u verhuisd of gaat u binnenkort weg? Vergeet dan niet om uw woonadres aan te passen!</p>
</div>
<div modal-actions alignment="between">
    <button type="button" class="btn btn--primary btn--block" (click)="verhuizen()">Ja, ik wil mijn adres aanpassen</button>
    <button type="button" class="btn btn--link btn--block" (click)="opzeggen()">Nee, ik wil alleen de verzekering opzeggen</button>
</div>
